import React from 'react'
import { Field, reduxForm } from 'redux-form'
import LgySelectField from 'app/components/util/lgy-select-field/LgySelectField'
import LgyInputField from 'app/components/util/lgy-input-field/LgyInputField'
import UserIsAffiliateCheckbox from '../components/UserIsAffiliateCheckbox'
import { accountStatusStringFromCode, accountStatuses } from 'app/utils/userUtils'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import LgyCheckbox from 'app/components/util/lgy-checkbox/LgyCheckbox'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import { maxLength, numeric } from 'app/utils/validations'

const maxLength15 = maxLength(15)

/**
 * Form for editing a user's account status
 * 
 * @author Alex Clary
 * @author Robbie Hinojosa
 */
const AccountStatusForm = ({ ...reduxForm }) => 
  <div>
    {reduxForm.submitSucceeded && <LgyAlertDialog type='success' heading='Status Updated' text='Account status information was updated successfully.' />}
    {reduxForm.error && <LgyAlertDialog type='error' heading='Update Failed' text='Account status information was not updated.' />}

    <form onSubmit={reduxForm.handleSubmit}>
      <Field component={LgySelectField} label='Account Status' name='accountStatusCode' required tooltip='There are two separate values for users for active status for historical reasons. For now, your best bet is to make them align.'>
        {Object.keys(accountStatuses).map(key => <option key={key} value={key}>{accountStatusStringFromCode(key)}</option>)}
      </Field>
      <Field component={LgyCheckbox} label='Active' name='active' />
      <Field component={UserIsAffiliateCheckbox} label='Affiliate User' name='isAffiliate' />
      <Field
        name='vaEauthSecId'
        type='text'
        component={LgyInputField}
        label='AccessVA SecID'
        tooltip="To unlink an AccessVA account from this LGY account, delete the SecID and submit the form. To link an AccessVA account to this account, set this value to be equal to their SecID. See the wiki for more details on how to find a user's SecID."
        validate={[maxLength15, numeric]}
      />
      <LgyFormSubmit {...reduxForm} />
    </form>
  </div>

export default reduxForm({})(AccountStatusForm)